module.exports = __webpack_public_path__ + "media/images/landing_page/failiem_upload_mobile-0b8ce3488f0a73c164b1c3ff2aaa2c7a.png";